import { observer } from 'mobx-react';
import { autoinject, bind, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AccountStore } from './AccountStore';

export interface ILoginCallbackProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class LoginCallbackView extends React.Component<ILoginCallbackProps> {
    public async componentDidMount() {
        const state = await this.accountStore.signinRedirectCallback();
        this.redirect(state);
    }

    public render() {
        return <div>Logging in...</div>;
    }

    @bind
    private redirect(state: any) {
        const returnUrl: string = state?.returnUrl ?? '/';

        if (returnUrl.startsWith('/')) {
            this.props.history.push(returnUrl);
        } else {
            throw new Error('Invalid return URL');
        }
    }

    @inject
    private accountStore!: AccountStore;
}
